var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['content', {wrapped: !!_vm.headline[_vm.type], left: _vm.align=='left', right: _vm.align=='right'}]},[(_vm.headline[_vm.type])?_c('h2',[_vm._v(_vm._s(_vm.headline[_vm.type]))]):_vm._e(),_vm._v(" "),_c(_vm.componentName,{tag:"component",attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68ac1dd2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/content-module.vue
// module id = null
// module chunks = 